<template>
  <div id="header">
    <nav
      class="navbar fixed-top navbar-expand-lg navbar-light bg-white"
      style="padding: 0"
    >
      <div class="container justify-content-center">
        <a class="navbar-brand" href="https://northerncontainersales.ca/">
          <img
            id="logo"
            style="height: 50px; padding-left: 20px"
            src="https://images-ncs.s3-us-west-2.amazonaws.com/New-Northern-Container-Sales-logo-225.png"
          />
        </a>
      </div>
    </nav>
  </div>
</template>

<script>
export default {
  name: "Header",
  data() {
    return {};
  },
};
</script>

<style scoped>
@import url(https://fonts.googleapis.com/css?family=Oswald:400);

#header {
  font-family: Arial, Helvetica, sans-serif;
  width: 90%;
  margin: auto;
}

nav {
  box-shadow: 0 5px 10px 0 rgba(0, 0, 0, 0.2);
  z-index: 100;
}

a:hover {
  color: #6dbe45;
}

img {
  height: 90px;
}
</style>
